import DirectivePhotoswipe from 'directive-photoswipe';
import Vue from 'vue';

Vue.use(DirectivePhotoswipe, {loop: false});
